import {NatOwnershipTransfersRepo} from '../repository/NatOwnershipTransfersRepo'
import NatCondominiumGroupRepo from '../../condominiumGroup/repository/NatCondominiumGroupRepo'
import NatCurrentDateTimeRepo from '../../currentDateTime/repository/NatCurrentDateTimeRepo'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {CondominiumGroupData, NatGetCondominiumGroup} from '../../condominiumGroup/repository/NatGetCondominiumGroup'
import {Nullable} from '../../../../app/TypeHelpers'
import {OwnershipTransferInfo, SearchCondition, SearchResult} from '../repository/NatGetOwnershipTransferList'
import {SortOrder} from '../../../../components/shared/SortOrder'
import React, {Component, ReactElement, ReactNode} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../../../components/shared/hoc/createAdminPage'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper,
} from '../../../common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {OWNERSHIP_TRANSFER_STATUS, ROLE_FOR_ADMINISTRATOR} from '../../../../CodeMaster'
import {COMMON_CONSTANTS} from '../../../../CommonConstants'
import ListSearchFormArea from '../../../../styledComponents/adminPage/ListSearchFormArea'
import {PageMainArea} from '../../../../components/shared/hoc/withAdminPageTemplate'
import styled from 'styled-components'
import SortableTableHeader, {
    SortableTableHeaderCell,
} from '../../../../styledComponents/adminPage/SortablePaginationTableHeader'
import SortablePaginationTable from '../../../../styledComponents/adminPage/SortablePaginationTable'
import SortablePaginationTableBody from '../../../../styledComponents/adminPage/SortablePaginationTableBody'
import {SortDirection} from '@mui/material/TableCell';
import {convertToRoomNumberForResident} from '../../../common/util/Natutil'
import {SearchResultCountDisplayProps} from '../../../../styledComponents/adminPage/SearchResultCountDisplay'
import {Messages} from '../../../../Messages'
import {Box, Link, TableCell, TableRow} from '@mui/material';
import {
    FullWidthLeftRowFlexContainer,
    LeftColumnFlexContainer,
    LeftRowFlexContainer,
    RightRowFlexContainer,
} from '../../../../styledComponents/FlexComponents'
import NatCondominiumGroupSelectComponent from '../../common/NatCondominiumGroupSelectComponent'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import {AdminDefaultMediumButton} from '../../../../styledComponents/adminPage/Buttons'
import PPCheckboxGroup from '../../../../components/shared/forms/PPCheckboxGroup'
import SearchPageActionArea from '../../../../styledComponents/adminPage/SearchPageActionArea'
import {HKConstants} from '../../../../HKConstants'
import AuthorityChecker from '../../../../components/AuthorityChecker'
import {formatForDateInputFromDate} from '../../../../formatters/formatDate'
import {StyledDiv, StyledSpan} from '../../../../styledComponents/StyledTypeDefinitions'
import PPDatePicker from '../../../../components/shared/forms/PPDatePicker'
import {Location} from 'react-router-dom'

const KEY_OWNERSHIP_TRANSFER_LIST_SEARCH_CONDITION: string = 'ownershipTransferListSearchCondition'
const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    ownershipTransfersRepo: NatOwnershipTransfersRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    condominiumGroup: Nullable<CondominiumGroupData>
    ownershipTransferList: OwnershipTransferInfo[]
    searchResult: SearchResult
    searchCondition: SearchCondition
    searchConditionSortInfo: SortOrder[]
    defaultApplyStatus: CheckBoxData[]
    noResultMessage: string
    isLoadCompleted: boolean
}

export interface CheckBoxData {
    id: string
    label: string
    disp: boolean
}

class NatAdminOwnershipTransferListPage extends Component<Props & AdminPagePropsSet, States> {
    subSortKey: SortOrder = new SortOrder('applyId', 'asc')

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        // 検索条件の初期設定
        let defaultSearchCondition: SearchCondition = {}
        let lastSearchCondition: SearchCondition = {}

        // 前回検索条件が保持されていればデフォルト値として設定する
        const sessionStorageSearchCondition: Nullable<string> =
            SessionStorageHelper.getStringItemOrNull(KEY_OWNERSHIP_TRANSFER_LIST_SEARCH_CONDITION)

        if (sessionStorageSearchCondition) {
            lastSearchCondition = JSON.parse(sessionStorageSearchCondition)
        } else {
            // 前回検索条件が保持されていない場合、申請ステータスは「発行済み」「入力中」で絞り込む
            const defaultStatus: string[] = []
            defaultStatus.push(OWNERSHIP_TRANSFER_STATUS.ISSUED.value)
            defaultStatus.push(OWNERSHIP_TRANSFER_STATUS.INPUTTING.value)
            defaultSearchCondition.applyStatus = defaultStatus.join(',')
        }

        if (lastSearchCondition.pageNum) {
            lastSearchCondition.pageNum = Number(lastSearchCondition.pageNum)
            lastSearchCondition.page = COMMON_CONSTANTS.FIRST_PAGE
        } else {
            defaultSearchCondition.pageNum = COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[2]
            defaultSearchCondition.page = COMMON_CONSTANTS.FIRST_PAGE
        }

        const loginUserCondominiumGroupId = NatAdminLoginInfoSessionStorageHelper.getNumberItemOrNull(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_ID)

        if (!defaultSearchCondition.condominiumGroupId &&
            loginUserCondominiumGroupId) {
            defaultSearchCondition.condominiumGroupId = loginUserCondominiumGroupId
        }


        if (Object.keys(lastSearchCondition).length) {
            defaultSearchCondition = {...lastSearchCondition}
        }

        this.state = {
            condominiumGroup: null,
            ownershipTransferList: [],
            searchCondition: defaultSearchCondition,
            searchConditionSortInfo: [
                new SortOrder('issueDatetime', 'desc'),
            ],
            defaultApplyStatus: [],
            searchResult: {},
            noResultMessage: '',
            isLoadCompleted: false,
        }

        this.onChangeCondominiumGroupId = this.onChangeCondominiumGroupId.bind(this)
        this.onChangeCondominiumCd = this.onChangeCondominiumCd.bind(this)
        this.onChangeCondominiumName = this.onChangeCondominiumName.bind(this)
        this.onChangeRidgeName = this.onChangeRidgeName.bind(this)
        this.onChangeRoomNumber = this.onChangeRoomNumber.bind(this)
        this.changeApplyId = this.changeApplyId.bind(this)
        this.onChangeCompleteStartDate = this.onChangeCompleteStartDate.bind(this)
        this.onChangeCompleteEndDate = this.onChangeCompleteEndDate.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.handleSortApplication = this.handleSortApplication.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.onClickIssueButton = this.onClickIssueButton.bind(this)
        this.onClickOwnershipTransferDataOutput = this.onClickOwnershipTransferDataOutput.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const condominiumGroupResponse = await this.getCondominiumGroup()

            this.setState({
                condominiumGroup: condominiumGroupResponse,
            })

            // 組合員資格変更届一覧取得
            await this.getOwnershipTransferList(
                this.state.searchCondition,
                this.state.searchConditionSortInfo,
            )
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    async getCondominiumGroup(): Promise<Nullable<CondominiumGroupData>> {
        const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
            this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return condominiumGroupResponse?.details ?? null
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    getDispApplyStatus(applyStatusCode: string): string {
        const applyStatus = OWNERSHIP_TRANSFER_STATUS.codeToEnumConstants(applyStatusCode)
        if (applyStatus) {
            return applyStatus.label
        } else {
            return ''
        }
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.page = newPage
        await this.getOwnershipTransferList(
            this.state.searchCondition,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchCondition: searchCondition})
    }

    async handleSortApplication(sortKey: string): Promise<void> {
        this.beforeUserAction()

        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        const sortOrders: SortOrder[] = [new SortOrder(sortKey, sortDirection)]
        await this.getOwnershipTransferList(
            this.state.searchCondition,
            sortOrders,
        )
        this.setState({searchConditionSortInfo: sortOrders})
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()

        // 検索条件を保持
        const lastSearchCondition: SearchCondition = {
            condominiumGroupId: this.state.searchCondition.condominiumGroupId,
            condominiumCd: this.state.searchCondition.condominiumCd,
            condominiumName: this.state.searchCondition.condominiumName,
            ridgeName: this.state.searchCondition.ridgeName,
            roomNumber: this.state.searchCondition.roomNumber,
            applyStatus: this.state.searchCondition.applyStatus,
            applyId: this.state.searchCondition.applyId,
            completeStartDate: this.state.searchCondition.completeStartDate,
            completeEndDate: this.state.searchCondition.completeEndDate,
            page: COMMON_CONSTANTS.FIRST_PAGE,
            pageNum: Number(event.target.value),

        }
        SessionStorageHelper.setItem(KEY_OWNERSHIP_TRANSFER_LIST_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))

        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.pageNum = Number(event.target.value)
        searchCondition.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.getOwnershipTransferList(
            this.state.searchCondition,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchCondition: searchCondition})
    }

    renderOwnershipTransferRecord(ownershipTransfer: OwnershipTransferInfo): ReactElement {
        const ownershipTransferUrl: string = `/admin/condominiums/${ownershipTransfer.condominiumCd}/applications/ownershipTransfers/${ownershipTransfer.applyId}`

        return (
            <TableRow key={ownershipTransfer.applyId}>
                <TableCell style={{width: '180px'}}>
                    <ApplyStatusCell status={ownershipTransfer.applyStatus} style={{width: '120px'}}>
                        {this.getDispApplyStatus(ownershipTransfer.applyStatus)}
                    </ApplyStatusCell>
                </TableCell>
                <TableCell style={{width: '115px'}}>
                    <Link href={ownershipTransferUrl} underline="hover">{ownershipTransfer.applyId}</Link>
                </TableCell>
                <TableCell style={{width: '280px'}}>
                    {ownershipTransfer.condominiumName}
                </TableCell>
                <TableCell style={{width: '120px'}}>
                    {`${ownershipTransfer.ridgeName} ${convertToRoomNumberForResident(ownershipTransfer.roomNumber)}`}
                </TableCell>
                <TableCellWordBreakAll style={{width: '180px'}}>
                    {ownershipTransfer.intermediaryName}
                </TableCellWordBreakAll>
                <TableCellWordBreakAll style={{width: '280px'}}>
                    {`${ownershipTransfer.issueRepFamilyName} ${ownershipTransfer.issueRepFirstName}`}
                </TableCellWordBreakAll>
                <TableCell style={{width: '200px'}}>
                    {ownershipTransfer.issueDatetime}
                </TableCell>
            </TableRow>
        )
    }

    renderOwnershipTransfersTable(ownershipTransferList: OwnershipTransferInfo[]): Nullable<ReactElement> {
        if (ownershipTransferList.length === 0) {
            return null
        }
        let headers: SortableTableHeaderCell[]

        headers = [
            {id: 'applyStatus', label: 'ステータス', align: 'left'},
            {id: 'applyId', label: '申請ID', align: 'left'},
            {id: 'condominiumName', label: '物件名', align: 'left'},
            {id: 'roomNumber', label: '部屋番号', align: 'left'},
            {id: 'intermediaryName', label: '仲介業者名', align: 'left'},
            {id: 'issueRepresentative', label: '発行担当者', align: 'left'},
            {
                id: 'issueDatetime',
                label: '発行日時',
                align: 'left',
                sortable: true,
                direction: this.getSortDirection('issueDatetime'),
            },
        ]

        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.searchResult.total ? this.state.searchResult.total : 0,
                    rowsPerPage:
                        this.state.searchCondition.pageNum ? this.state.searchCondition.pageNum : 0,
                    page: this.state.searchCondition.page ? this.state.searchCondition.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >
                <SortableTableHeader
                    noWrap
                    headers={headers}
                    onSortOrderChange={this.handleSortApplication}
                />
                <SortablePaginationTableBody>
                    {this.state.ownershipTransferList.map(
                        ownershipTransfer =>
                            this.renderOwnershipTransferRecord(ownershipTransfer),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    searchResults(): SearchResultCountDisplayProps {
        if (this.state.ownershipTransferList.length === 0) {
            return {noResultMessage: this.state.noResultMessage}
        }

        return {
            totalCount: this.state.searchResult.total ? this.state.searchResult.total : undefined,
            rowsPerPage: this.state.searchCondition.pageNum,
            page: this.state.searchCondition.page,
        }
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    async getOwnershipTransferList(
        searchCondition: SearchCondition,
        searchConditionSortInfo: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {
            const ownershipTransferListResponse = await this.props.asyncCallFunction(
                this.props.ownershipTransfersRepo.getOwnershipTransferList.bind(
                    this.props.ownershipTransfersRepo,
                    searchCondition, [...searchConditionSortInfo, this.subSortKey]),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            if (ownershipTransferListResponse?.details) {
                let noResultMessage: string = ''
                if (ownershipTransferListResponse.details.searchResult.total === 0) {
                    noResultMessage = Messages.IOPCC0014.toString()
                }

                this.setState({
                    noResultMessage: noResultMessage,
                    ownershipTransferList: ownershipTransferListResponse.details.ownershipTransfersListInfo,
                    searchResult: ownershipTransferListResponse.details.searchResult,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async onClickOwnershipTransferDataOutput(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const searchCondition: SearchCondition = {
                condominiumGroupId: this.state.searchCondition.condominiumGroupId,
                condominiumCd: this.state.searchCondition.condominiumCd,
                condominiumName: this.state.searchCondition.condominiumName,
                ridgeName: this.state.searchCondition.ridgeName,
                roomNumber: this.state.searchCondition.roomNumber,
                applyStatus: this.state.searchCondition.applyStatus,
                applyId: this.state.searchCondition.applyId,
                completeStartDate: this.state.searchCondition.completeStartDate,
                completeEndDate: this.state.searchCondition.completeEndDate,
            }
            const tempLink: HTMLAnchorElement = document.createElement('a')
            tempLink.href = this.props.ownershipTransfersRepo.exportOwnershipTransferListByCsvData(searchCondition)
            document.body.appendChild(tempLink)
            tempLink.click()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async onClickSearchButton(): Promise<void> {
        this.beforeUserAction()
        // 検索条件を保持
        const lastSearchCondition: SearchCondition = {
            condominiumGroupId: this.state.searchCondition.condominiumGroupId,
            condominiumCd: this.state.searchCondition.condominiumCd,
            condominiumName: this.state.searchCondition.condominiumName,
            ridgeName: this.state.searchCondition.ridgeName,
            roomNumber: this.state.searchCondition.roomNumber,
            applyStatus: this.state.searchCondition.applyStatus,
            applyId: this.state.searchCondition.applyId,
            completeStartDate: this.state.searchCondition.completeStartDate,
            completeEndDate: this.state.searchCondition.completeEndDate,
            pageNum: this.state.searchCondition.pageNum,
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        SessionStorageHelper.setItem(
            KEY_OWNERSHIP_TRANSFER_LIST_SEARCH_CONDITION,
            JSON.stringify(lastSearchCondition),
        )

        const searchCondition = this.state.searchCondition
        searchCondition.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.getOwnershipTransferList(
            searchCondition,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchCondition: searchCondition})
    }

    onChangeCondominiumGroupId(condominiumGroupId: number): void {
        const searchConditions = this.state.searchCondition
        searchConditions.condominiumGroupId = condominiumGroupId
        this.setState({searchCondition: searchConditions})
    }

    onChangeCondominiumCd(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition
        searchConditions.condominiumCd = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    onChangeCondominiumName(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition
        searchConditions.condominiumName = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    onChangeRidgeName(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition
        searchConditions.ridgeName = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    onChangeRoomNumber(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition
        searchConditions.roomNumber = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    judgeCheckStatus(applyStatus: string): boolean {
        if (!this.state.searchCondition || !this.state.searchCondition.applyStatus) {
            return false
        }
        const roleArray: string[] = this.state.searchCondition.applyStatus.split(',')
        return roleArray.indexOf(applyStatus) >= 0
    }

    clickApplyStatus(label: string, checked: boolean): void {

        const checkedStatus = OWNERSHIP_TRANSFER_STATUS.values().filter(role => {
            return role.label === label
        })

        if (this.state.searchCondition.applyStatus) {
            const checkedStatusArray: string[] = this.state.searchCondition.applyStatus.split(',')
            if (checked) {
                checkedStatusArray.push(checkedStatus[0].value)
            } else {
                checkedStatusArray.splice(checkedStatusArray.indexOf(checkedStatus[0].value), 1)
            }
            const searchCondition = this.state.searchCondition
            searchCondition.applyStatus = checkedStatusArray.join(',')
            this.setState({searchCondition: searchCondition})
        } else {
            if (checked) {
                const searchCondition = this.state.searchCondition
                searchCondition.applyStatus = checkedStatus[0].value
                this.setState({searchCondition: searchCondition})
            }
        }
    }

    renderApplyStatusCheckBox(): ReactNode {
        const labels: { label: string, checked: boolean }[] = []
        const applyStatusMaster = OWNERSHIP_TRANSFER_STATUS.values()

        applyStatusMaster
            .map((applyStatus) => (
                labels.push(
                    {
                        label: applyStatus.label,
                        checked: this.judgeCheckStatus(applyStatus.value),
                    },
                )
            ))

        return (
            <StyledPPCheckboxGroup
                row
                data={labels}
                onChangeChecked={this.clickApplyStatus.bind(this)}
            />
        )
    }

    changeApplyId(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.applyId = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    onChangeCompleteStartDate(date: Nullable<Date>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.completeStartDate = date ? formatForDateInputFromDate(date) : ''
        this.setState({searchCondition: searchCondition})
    }

    onChangeCompleteEndDate(date: Nullable<Date>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.completeEndDate = date ? formatForDateInputFromDate(date) : ''
        this.setState({searchCondition: searchCondition})
    }

    async onClickIssueButton(): Promise<void> {
        this.props.navigate(
            '/admin/applications/ownershipTransfers/register',
        )
    }

    renderOwnershipTransfersSearchInfo(): ReactNode {
        return (
            <>
                <Box pl={'8px'} pt={'8px'}>
                    <LeftRowFlexContainer>
                        <SearchCategoryColumnContainer>物件情報</SearchCategoryColumnContainer>
                        <Box width={'126px'}>物件グループを選択</Box>
                        <SearchInputContainer>
                            <LeftColumnFlexContainer>
                                <Box width={'300px'} ml={'8px'}>
                                    {this.state.condominiumGroup &&
                                        <NatCondominiumGroupSelectComponent
                                            condominiumGroup={this.state.condominiumGroup}
                                            onChangeSelectedCondominiumGroupId={this.onChangeCondominiumGroupId}
                                            defaultValue={(this.state.searchCondition.condominiumGroupId) ?
                                                this.state.searchCondition.condominiumGroupId : null}
                                            requiredFlag={true}
                                            eventKeys={['condominiumGroupId']}
                                            eventEmitter={this.props.eventEmitter}
                                            autoFocus={true}
                                        />
                                    }
                                </Box>
                            </LeftColumnFlexContainer>
                        </SearchInputContainer>
                    </LeftRowFlexContainer>
                    <SearchRowContainer>
                        <SearchCategoryColumnContainer/>
                        <SearchColumnContainerForAll>物件コード</SearchColumnContainerForAll>
                        <SearchInputContainer>
                            <Box width={'300px'}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 6,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.onChangeCondominiumCd}
                                    defaultValue={this.state.searchCondition.condominiumCd}
                                />
                            </Box>
                        </SearchInputContainer>
                        <SearchColumnContainerForAll/>
                        <SearchColumnContainerForAll>物件名</SearchColumnContainerForAll>
                        <SearchInputContainer>
                            <Box width={'300px'}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.onChangeCondominiumName}
                                    defaultValue={this.state.searchCondition.condominiumName}
                                />
                            </Box>
                        </SearchInputContainer>
                    </SearchRowContainer>
                    <SearchRowContainer>
                        <SearchCategoryColumnContainer/>
                        <SearchColumnContainerForAll>棟名</SearchColumnContainerForAll>
                        <SearchInputContainer>
                            <Box width={'170px'}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 20,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.onChangeRidgeName}
                                    defaultValue={this.state.searchCondition.ridgeName}
                                />
                            </Box>
                        </SearchInputContainer>
                        <SearchColumnContainerForAll/>
                        <SearchColumnContainerForAll>部屋番号</SearchColumnContainerForAll>
                        <SearchInputContainer>
                            <Box width={'170px'}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 4,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.onChangeRoomNumber}
                                    defaultValue={this.state.searchCondition.roomNumber}
                                />
                            </Box>
                        </SearchInputContainer>
                    </SearchRowContainer>
                    <SearchRowContainer>
                        <SearchCategoryColumnContainer>申請情報</SearchCategoryColumnContainer>
                        <SearchColumnContainerForAll>ステータス</SearchColumnContainerForAll>
                        <SearchInputContainer>
                            {this.renderApplyStatusCheckBox()}
                        </SearchInputContainer>
                    </SearchRowContainer>
                    <SearchRowContainer>
                        <SearchCategoryColumnContainer/>
                        <SearchColumnContainerForAll>申請ID</SearchColumnContainerForAll>
                        <SearchInputContainer>
                            <Box width={'170px'}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 8,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.changeApplyId}
                                    defaultValue={this.state.searchCondition.applyId}
                                    eventKeys={['applyId']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </Box>
                        </SearchInputContainer>
                    </SearchRowContainer>
                    <LeftRowFlexContainer>
                        <SearchCategoryColumnContainer/>
                        <SearchColumnContainerForAll>提出完了日</SearchColumnContainerForAll>
                        <LeftRowFlexContainer>
                            <SearchInputContainer>
                                <Box width={'236px'}>
                                    <TermWrapper>
                                        <FlexBasis>
                                            <PPDatePicker
                                                onChangeDate={this.onChangeCompleteStartDate}
                                                value={this.state.searchCondition.completeStartDate
                                                    ? new Date(this.state.searchCondition.completeStartDate)
                                                    : null
                                                }
                                                maxDate={this.state.searchCondition.completeEndDate
                                                    ? new Date(this.state.searchCondition.completeEndDate)
                                                    : undefined
                                                }
                                            />
                                        </FlexBasis>
                                        <TermTxt>から</TermTxt>
                                    </TermWrapper>
                                </Box>
                            </SearchInputContainer>
                            <Box width={'236px'}>
                                <TermWrapper>
                                    <FlexBasis>
                                        <PPDatePicker
                                            onChangeDate={this.onChangeCompleteEndDate}
                                            value={this.state.searchCondition.completeEndDate
                                                ? new Date(this.state.searchCondition.completeEndDate)
                                                : null
                                            }
                                            minDate={this.state.searchCondition.completeStartDate
                                                ? new Date(this.state.searchCondition.completeStartDate)
                                                : undefined
                                            }
                                        />
                                    </FlexBasis>
                                    <TermTxt>まで</TermTxt>
                                </TermWrapper>
                            </Box>
                        </LeftRowFlexContainer>
                        <Box flex={1} ml={'16px'}>
                            <RightRowFlexContainer>
                                <SearchButton onClick={this.onClickSearchButton}>
                                    検索する
                                </SearchButton>
                            </RightRowFlexContainer>
                        </Box>
                    </LeftRowFlexContainer>
                </Box>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return <>
            <ListSearchFormArea
                searchResult={this.searchResults()}
                onEnterKey={this.onClickSearchButton}>
                {this.renderOwnershipTransfersSearchInfo()}
            </ListSearchFormArea>
            <SearchPageActionArea>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.ISSUE_OWNERSHIP_TRANSFER}>
                    <ButtonArea>
                        <AdminDefaultMediumButton onClick={this.onClickIssueButton}>
                            発行
                        </AdminDefaultMediumButton>
                        {SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)
                            === ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value &&
                            <AdminDefaultMediumButton onClick={this.onClickOwnershipTransferDataOutput}>
                                組合員資格変更届データ出力
                            </AdminDefaultMediumButton>
                        }
                    </ButtonArea>
                </AuthorityChecker>
            </SearchPageActionArea>
            <PageMainArea>
                {this.renderOwnershipTransfersTable(this.state.ownershipTransferList)}
            </PageMainArea>
        </>
    }
}

export default createAdminPage(NatAdminOwnershipTransferListPage)

const ApplyStatusCell = styled.button<{ status?: string }>`
  width: 156px;
  height: 29px;
  border: 0;
  border-radius: 40px;
  background: ${props => props.status === '8' ? 'linear-gradient(0deg, rgba(0, 175, 185, 0.4), rgba(0, 175, 185, 0.4)), #FFFFFF;' :
          props.status === '9' ? 'linear-gradient(0deg, #EDEDED, #EDEDED), #FFFFFF;' :
                  'linear-gradient(0deg, rgba(255, 191, 86, 0.4), rgba(255, 191, 86, 0.4)), #FFFFFF;'}
`

const SearchButton = styled(AdminDefaultMediumButton)`
  &.MuiButtonBase-root {
    width: 204px;
    height: 44px;
  }
`

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`

const SearchRowContainer = styled(FullWidthLeftRowFlexContainer)`
  padding: 8px 0;
`

const SearchCategoryColumnContainer = styled.div`
  font-weight: bold;
  width: 56px;
  margin-right: 24px;
  flex-shrink: 0;
`

const StyledPPCheckboxGroup = styled(PPCheckboxGroup)`
  & .MuiTypography-root {
    font-size: 14px;
  }
`

const SearchColumnContainerForAll = styled.div`
  width: 104px;
  flex-shrink: 0;
`

const SearchInputContainer = styled.div`
  margin-left: 16px;
`

const ButtonArea: StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
`

const TermWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
`

const TermTxt: StyledSpan = styled.span`
  padding: 0 24px 0;
`

const FlexBasis: StyledDiv = styled.div`
  flex: 1 1 0%;
  padding-bottom: 4px;
  padding-top: 8px;
`
